import {QuickFactory} from './quick-factory';
import {SelectableEntity} from '../../../model/entity/selectable-entity';
import {Factory} from './factory';

export class SelectableFactory extends QuickFactory implements Factory<SelectableEntity> {

  constructor(
    private api: string,
    private settings: {
      idField?: string,
      labelField?: string[],
      displayId?: boolean,
      displayLabel?: boolean,
      colorField?: string
    } = {}) {
    super();
    const displayId = this.settings.displayId;
    this.settings.displayId = displayId !== null && displayId !== undefined ? displayId : true;
    const displayLabel = this.settings.displayLabel;
    this.settings.displayLabel = displayLabel !== null && displayLabel !== undefined ? displayLabel : true;

  }
  build(o: any): SelectableEntity {
    const label = this.settings.labelField.map((l) => o[l]).join(' ');
    const display =  this.settings.displayId && this.settings.displayLabel ? 'full' : (this.settings.displayLabel) ? 'label' : 'id';
    const e = new SelectableEntity(o[this.settings.idField], label, display);
    if (this.settings.colorField) {
      e.icon = 'square icon-bold';
      e.iconColor = o[this.settings.colorField];
    }
    this.generateProperty(e, o);
    return e;
  }

  getApi(): string {
    return this.api;
  }
}
